import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import WarningModal from 'shared/lib/components/modals/warningModal';
import React, { useContext } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { trashApi } from 'entities/trash/api/trashApi';

export type FinallyDeleteTableModalActions = {
  afterTableDelete?: (id: string) => void;
};

export default observer(function FinallyDeleteTableModalController({
  id,
  afterTableDelete,
  handleClose,
}: {
  id: string;
  handleClose: () => void;
} & FinallyDeleteTableModalActions) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.finallyDelete.tableMain')}
        secondText={t('warnings.finallyDelete.tableSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await trashApi.deleteTable(id);
            afterTableDelete && afterTableDelete(id);
            handleClose();
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
            handleClose();
          }
        }}
      ></WarningModal>
    </>
  );
});
